import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Platform } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-printer-list-modal',
  templateUrl: 'printer-list-modal.html',
})
export class PrinterListModalPage {
  printerList:any=[];
  callback;
  constructor(public navCtrl: NavController, public platform: Platform,public navParams: NavParams, private viewCtrl:ViewController) {
  
    this.platform.registerBackButtonAction(() => {
      this.callback();
      this.navCtrl.pop();
    },1);
  }

  ionViewWillEnter() {
     this.callback = this.navParams.get("callback");
  }
  
  ionViewWillLeave() {
    this.callback();
  }
  ionViewDidLoad() {
    this.printerList=this.navParams.get('data');

  }

  select(data)
  {
    this.viewCtrl.dismiss(data);
  }

}



// WEBPACK FOOTER //
// ./src/pages/printer-list-modal/printer-list-modal.ts